<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <ContractEditComponent/>

    </transition>
  </div>
</template>

<script>

import ContractEditComponent from '@/components/contracts/ContractEditComponent.vue'

export default {
  name: 'Contract',
  components: {
    ContractEditComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
